import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ล่ามศาล — ล่ามคดีแพ่ง อาญา ครอบครัว ในศาลไทยทุกภาค","metaTitle":"ล่ามศาล (Court Interpreter) — ล่ามคดีแพ่ง/อาญา ทั่วไทย | NYC","metaDesc":"บริการล่ามศาลไทย (Court Interpreter) คดีแพ่ง อาญา ครอบครัว ล้มละลาย /ครึ่งวัน มีใบรับรองประกอบสำนวน ทำงานได้ 4 — ส่งภาพเอกสารมาเช็กให้ก่อน ฟรี ไม่คิดค่าปรึกษา"},"en":{"h1":"Court Interpreter — Civil, Criminal, Family Cases in Thai Courts","metaTitle":"Court Interpreter Thailand — Civil / Criminal / Family Cases | NYC","metaDesc":"Certified Thai court interpreters for civil, criminal, family, and IP cases nationwide. per half-day. 40+ — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/en/interpreter/court")({
  head: () => {
    const url = `${SEO_SITE}/en/interpreter/court`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/interpreter/court", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/interpreter/court", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/interpreter/court", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/interpreter/court", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/interpreter/court", "/en/interpreter/court")],
    };
  },
  component: () => <SubServicePage slug="interpreter/court" locale="en" />,
});
